import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

const TypographyBodyTwo = styled(Typography)(({ theme, style }) => ({
    fontWeight: 'normal',
    color: theme.palette.text.secondary,
    fontSize: 14,
    textTransform: 'none',
    ...style,
}));

export default TypographyBodyTwo;
